import { DateRange, Range, RangeKeyDict } from 'react-date-range';

import Tooltip from '@components/tooltip/Tooltip';
import { CalendarProps } from '@types';

import {
  CALENDAR_DISABLED_DAY_TOOLTIP_ID,
  isDateOutsideSelectableRange,
  renderDayWithDisabledTooltip
} from './disabledDateHelpers';

import colors from '../../../themes/colors';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import '@components/date-picker/styles.css';

const Calendar: React.FC<CalendarProps> = ({
  startDate,
  endDate,
  handleChange,
  maxDate,
  minDate,
  className = '',
  disabledDateData
}) => {
  const currentDate = new Date();
  const selectionRange: Range = {
    startDate: startDate || currentDate,
    endDate: endDate || currentDate,
    key: 'selection'
  };

  const handleSelect = (ranges: RangeKeyDict) => {
    if (!handleChange) {
      return;
    }

    const { selection } = ranges;
    const { startDate: rangeStart, endDate: rangeEnd } = selection;

    if (
      disabledDateData &&
      rangeStart &&
      rangeEnd &&
      (isDateOutsideSelectableRange(rangeStart, disabledDateData) ||
        isDateOutsideSelectableRange(rangeEnd, disabledDateData))
    ) {
      return;
    }

    handleChange({ selection });
  };

  const effectiveMaxDate = disabledDateData?.maxDate ?? maxDate;
  const usesDisabledDateData = Boolean(disabledDateData);

  return (
    <div className="date-picker flex w-full flex-col items-center justify-center">
      <DateRange
        ranges={[selectionRange]}
        onChange={handleSelect}
        showDateDisplay={false}
        className={`!bg-bgBase !text-content ${className}`}
        showMonthAndYearPickers={false}
        rangeColors={[`${colors.primary}`]}
        maxDate={effectiveMaxDate}
        {...(!usesDisabledDateData && { minDate })}
        {...(usesDisabledDateData && {
          disabledDay: (date: Date) =>
            isDateOutsideSelectableRange(date, disabledDateData),
          dayContentRenderer: (date: Date) =>
            renderDayWithDisabledTooltip(date, disabledDateData)
        })}
      />
      {usesDisabledDateData && (
        <Tooltip
          id={CALENDAR_DISABLED_DAY_TOOLTIP_ID}
          type="text"
          place="top"
        />
      )}
    </div>
  );
};

export default Calendar;
